module.exports = __webpack_public_path__ + "img/no-content.c2cb651f.svg";